/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import type {
  FieldPolicy,
  FieldReadFunction,
  StoreValue,
} from '@apollo/client';
import dayjs, { isDayjs } from 'dayjs';

/**
 * @url https://www.apollographql.com/docs/react/caching/cache-field-behavior/
 */
export const dateTimeFieldPolicy:
  | FieldPolicy<StoreValue>
  | FieldReadFunction<StoreValue> = {
  read(dateTime) {
    return typeof dateTime === 'string'
      ? dayjs(dateTime)
      : isDayjs(dateTime)
      ? dateTime
      : null;
  },
};
